import { sylvanus } from '~/services/serviceInstances';

import {
  type DdeModel,
  type LooseServerDdeModel,
  mapDdeModel,
} from './ddeModelTypes';

type ListDdeModelsRequest = {
  tableId: string;
};

type ListDdeModelsResponse =
  | LooseServerDdeModel[]
  | {
      items?: LooseServerDdeModel[];
    };

const mapResponse = (response: ListDdeModelsResponse): DdeModel[] => {
  const models = Array.isArray(response) ? response : (response.items ?? []);

  return models.map(mapDdeModel).filter((model) => Boolean(model.id));
};

export const listDdeModels = async ({
  tableId,
}: ListDdeModelsRequest): Promise<DdeModel[]> => {
  const response = await sylvanus.get<ListDdeModelsResponse>(
    `/dde/table/${tableId}/models`,
  );

  return mapResponse(response ?? []);
};
